import { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./styles.scss";
import Loader from "./common/Loader";

const Home = lazy(() => import("./pages/Home"));
const Approve = lazy(() => import("./pages/Approve"));
const Login = lazy(() => import("./pages/Login"));

export default function App() {
  return (
    <Router>
      <div className="App">
        <Suspense fallback={<Loader type="default" />}>
          <Routes>
            <Route path="/approve" element={<Approve />} />
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Home />} />
          </Routes>
          {/* <Home /> */}
        </Suspense>
      </div>
    </Router>
  );
}
